const routes = {
  home: '/',
  steps: {
    withPage: '/step/:page/:subpage?',
    root: '/step',
    submitProfile: '/step/submit',
    success: '/step/success',
  },
  signIn: '/sign-in',
  signInCallback: '/login/callback',
  signOut: '/sign-out',
  signOutCallback: '/logout/callback',
} as const;

export default routes;
